<st-simple-search-box
    st-click-stop-propagation
    class="st-simple-search-box-autocomplete__search"
    [suggestions]="suggestions()"
    (searchThermChange)="onSearchTermHandler($event)"
    (searchExecuted)="onSearchHandler($event)" />
